import { SENSOR_DEFAULT_ICON } from '@/constants/sensor';
import { qx_ePrivilege_enum } from '@/graphql/types';
import { ConfigRouteObject } from '@/types';

/**
 * Intrusion zones are masked as sensor siblings (Zone Plan B) and share this list/nav entry -
 * see [SensorsAndZonesListPage.vue](src/views/sensors/SensorsAndZonesListPage.vue).
 */
export const SENSORS_ROUTE: ConfigRouteObject = {
  UI_ICON: ['fal', SENSOR_DEFAULT_ICON],
  UI_LABEL: 'Sensors & Zones',
  ROUTE_PATH: 'sensors',
  ROUTE_NAME: 'sensor.index',
  ROUTE_PARAM: '',
  PRIVILEGES: [qx_ePrivilege_enum.DeviceView]
};

export const SENSOR_CREATE_ROUTE: ConfigRouteObject = {
  UI_ICON: ['fal', SENSOR_DEFAULT_ICON],
  UI_LABEL: 'Create Sensor',
  ROUTE_PATH: 'create',
  ROUTE_NAME: 'sensor.create',
  ROUTE_PARAM: '',
  PRIVILEGES: [qx_ePrivilege_enum.DeviceConfig]
};

export const SENSOR_EDIT_ROUTE: ConfigRouteObject = {
  UI_ICON: ['fas', 'pen-to-square'],
  UI_LABEL: 'Edit Sensor',
  ROUTE_PATH: 'edit',
  ROUTE_NAME: 'sensor.edit',
  ROUTE_PARAM: 'sensorId',
  PRIVILEGES: [qx_ePrivilege_enum.DeviceConfig]
};

// name used between two route names
const SENSOR_VIEW_ROUTE_NAME_SHARED = 'sensor.view';

// this route does not register it's ROUTE_NAME
// that is because it would duplicate the info route
export const SENSOR_VIEW_ROUTE: ConfigRouteObject = {
  UI_ICON: ['fas', SENSOR_DEFAULT_ICON],
  UI_LABEL: 'View Sensor',
  ROUTE_PATH: ':sensorId',
  ROUTE_NAME: SENSOR_VIEW_ROUTE_NAME_SHARED,
  ROUTE_PARAM: 'sensorId',
  PRIVILEGES: [qx_ePrivilege_enum.DeviceView]
};

export const SENSOR_VIEW_INFO_ROUTE: ConfigRouteObject = {
  UI_ICON: ['fas', 'circle-info'],
  UI_LABEL: 'Info',
  ROUTE_PATH: '',
  ROUTE_NAME: SENSOR_VIEW_ROUTE_NAME_SHARED,
  ROUTE_PARAM: 'sensorId',
  PRIVILEGES: [qx_ePrivilege_enum.DeviceView]
};

export const SENSOR_VIEW_SETTINGS_ROUTE: ConfigRouteObject = {
  UI_ICON: ['fas', 'sitemap'],
  UI_LABEL: 'Settings',
  ROUTE_PATH: 'settings',
  ROUTE_NAME: 'sensor.view.settings',
  ROUTE_PARAM: 'sensorId',
  PRIVILEGES: [qx_ePrivilege_enum.DeviceConfig]
};
